import styled from 'styled-components';

import { breakpoints } from '@styles/breakpoint';
import { Spacers } from '@styles/theme';

export const RequestResetWrapper = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;

  ${breakpoints.desktopOrBigger} {
    justify-content: center;
  }
`;

export const InputWrapper = styled.div`
  margin-block: ${Spacers.LG}rem;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacers.BASE}rem;
`;
